import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import { CONTRACT_SALES_LISTING } from "./type";

export const getApprovedSaleListing = (leadId = 1383,queryObj = null, page = 1) => async (dispatch) => {

  let filterQuery = "";
  if (queryObj !== null) {
    filterQuery = `&status=${queryObj.leadStatus}&client_name=${queryObj.clientNameOrPartnerName}&created_on=${queryObj.createdOnDate}&from_date=${queryObj.fromDate}&to_date=${queryObj.toDate}&assigned_to=${queryObj.leadOwnerOrAssignee}&city=${queryObj.city}&zone=${queryObj.zone}&lead_cat=${queryObj.lead_cat}&lcfrom_date=${queryObj.lcfromDate}&lcto_date=${queryObj.lctoDate}&ncfrom_date=${queryObj.ncfromDate}&ncto_date=${queryObj.nctoDate}&page=${page}`;
  }
  
  try {
    const teamName = await JSON.parse(localStorage.getItem("profileDetails"))[0]
      .team_id;
    const departmentName = await JSON.parse(
      localStorage.getItem("profileDetails")
    )[0].department_id;
    let apiUrl;
    if (departmentName && departmentName === 2) {
      if (teamName && teamName === 7) {
        apiUrl = queryObj
        ? `${Config.preSalesList.contractList}?lead_id=${leadId}&lead_type=1${filterQuery}`
        : `${Config.preSalesList.contractList}?lead_id=${leadId}&lead_type=1`;
      } else if (teamName && teamName === 9) {
        apiUrl = queryObj
        ? `${Config.preSalesList.contractList}?lead_id=${leadId}&lead_type=4${filterQuery}`
        : `${Config.preSalesList.contractList}?lead_id=${leadId}&lead_type=4`;
      } else if (teamName && teamName === 8) {
        apiUrl = queryObj
        ? `${Config.preSalesList.contractList}?lead_id=${leadId}&lead_type=2${filterQuery}`
        : `${Config.preSalesList.contractList}?lead_id=${leadId}&lead_type=2`;
      } else {
        apiUrl = queryObj
        ? `${Config.preSalesList.contractList}?lead_id=${leadId}&lead_type=3${filterQuery}`
        : `${Config.preSalesList.contractList}?lead_id=${leadId}&lead_type=3`;
      }
    } else if(teamName && teamName === 16) {
      apiUrl = queryObj
      ? `${Config.preSalesList.contractList}?lead_id=${leadId}&lead_type=4${filterQuery}`
      : `${Config.preSalesList.contractList}?lead_id=${leadId}&lead_type=4`;
    }else if (teamName && teamName === 21) {
      apiUrl = queryObj
          ? `${Config.preSalesList.contractList}?lead_id=${leadId}&lead_type=1${filterQuery}`
          : `${Config.preSalesList.contractList}?lead_id=${leadId}&lead_type=1`;
    }

    dispatch({
      type: CONTRACT_SALES_LISTING,
      payload: {},
    });

    const res = await callWebService(
      callTypes.get,
      "",
      `${apiUrl}${queryObj === null ? `&page=${page}` : ""}`
    );

    if (res) {
      const outer = res.data;
      const payload = outer?.response ?? outer;
      dispatch({
        type: CONTRACT_SALES_LISTING,
        payload: payload?.data ?? outer?.data,
      });
      return true;
    }
  }
  catch {
    dispatch({
      type: CONTRACT_SALES_LISTING,
      payload: {},
    });
  }
};
